import dayjs from "@/helpers/dayjs";
import XLSX from "xlsx";
import Datepicker from "vuejs-datepicker";
import { ko } from "vuejs-datepicker/dist/locale";
export default {
  data() {
    return {
      ko: ko,
      loading: false,
      date: {
        from: dayjs().format("YYYY-MM-01"),
        to: dayjs().format("YYYY-MM-DD")
      }
    };
  },
  components: {
    Datepicker
  },
  watch: {
    "date.from"(newFrom) {
      const maxAllowedToDate = dayjs(newFrom).add(39, "days");
      const today = dayjs().format("YYYY-MM-DD");
      this.date.to = dayjs(maxAllowedToDate).isAfter(today)
        ? today
        : maxAllowedToDate.format("YYYY-MM-DD");
    }
  },
  computed: {
    fromDisableDate() {
      const vm = this;

      const from = new Date(dayjs());
      // const to = new Date(dayjs().subtract("91", "days"));

      return { from };
    },
    toDisableDate() {
      const vm = this;
      let from = dayjs(vm.date.from).add("39", "days");
      const check = dayjs().diff(from, "days");

      if (Math.sign(check) === -1) {
        const time = String(39 + check);
        from = dayjs(vm.date.from).add(time, "days");
      }

      const to = new Date(dayjs(vm.date.from));
      from = new Date(from);
      return { from, to };
    }
  },
  methods: {
    getOrderList() {
      const vm = this;

      vm.loading = true;

      const payload = {
        from: dayjs(vm.date.from).format("YYYY-MM-DD"),
        to: dayjs(vm.date.to).format("YYYY-MM-DD")
      };
      const callStore =
        vm.permission === "manager"
          ? "orders/getUserOrderList"
          : "orders/getMemberOrderList";

      vm.$store
        .dispatch(callStore, payload)
        .then((result) => {
          if (result.code === 404) {
            alert("해당일자에 사용내역이 없습니다.");
            return (vm.loading = false);
          }
          vm.downloadOrders(result.exportList);
          vm.loading = false;
        })
        .catch((e) => {
          console.error(e);
          vm.loading = false;
          if (e.code === 500) return alert("서버 오류가 발생하였습니다.");
          if (e.code === 400) return alert("선택일자를 다시 확인해주세요.");
        });
    },

    downloadOrders(data) {
      const vm = this;
      const orderData = [];

      data.forEach(async (list) => {
        await orderData.push({
          고객명: list.userName,
          아이디: list.userId,
          주문번호: list._id,
          주문일자: list.orderTime,
          픽업시간: list.pickupAt,
          완료시간: list.completedAt,
          출발지: list.departureAddr,
          발송인: list.senderName,
          발송인연락처: list.senderPhoneNumber,
          도착지: list.lastAddr,
          수신인: list.receiverName,
          수신인연락처: list.receiverPhoneNumber,
          경유지개수: list.waypoints,
          물품정보: list.item,
          배송무게: list.weight,
          주문상태: list.status,
          배송수단: list.vehicleName,
          배송요금: list.totalDeliveryFee,
          기본요금: list.baseFee,
          거리요금: list.distanceFee,
          무게요금: list.weightFee,
          "거리별 기본요금": list.freightDistanceFee,
          옵션요금: list.freightOptionsFee,
          경유요금: list.waypointsFee,
          급송요금: list.expressDeliveryFee,
          "배송요금 백단위절사": list.fixedFee,
          할증요금: list.totalExtraFee,
          시간할증: list.timeFee,
          기상할증: list.weatherFee,
          특수일할증: list.specialDayFee,
          "할증요금 백단위절사": list.extraFixedFee,
          부가세: list.vat,
          "후청구요금(부가세포함)": list.additionalPrice,
          결제금액: list.totalFee,
          주문메모: list.clientMemo
        });
      });

      const ws = XLSX.utils.json_to_sheet(orderData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, dayjs().format("YYYY-MM-DD"));
      XLSX.writeFile(
        wb,
        `디버_사용내역_${vm.permission === "manager" ? "" : "구성원_"}${dayjs(
          vm.date.from
        ).format("YYYY-MM-DD")}_${dayjs(vm.date.to).format("YYYY-MM-DD")}.xlsx`
      );
    }
  },
  props: ["permission"]
};
